import React, { useState } from 'react';
import { connect } from 'react-redux';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReportTab from '../ReportTab';
import BtnRefresh from '../buttons/BtnRefresh';
import BtnExpand from '../buttons/BtnExpand';
import RptSingleTotal from './views/RptSingleTotal';

import { errorMessage, onlyUnique, sdpName, rptTotal, rptTotalQty } from '../functions';

const mapStateToProps = (state) => {
        return {
		apiServer: state.apiServer,
		agent: state.agent,
		uid: state.uid,
		session: state.session,
                periodType: state.periodType,
                periodDate: state.periodDate
        }
}

const mapDispatchToProps = { errorMessage }

function RptSubDeptSingleTotal(props) {
	const [rpt_sub, setRptSub] = useState([]);

	const refresh = () => {
		console.log('RptSubDeptSingleTotal.js refresh invoked');

		var F1031 = props.periodType;
		var F254 = props.periodDate;

		console.log('RptSubDeptSingleTotal.js requesting: ' + props.apiServer + '?uid='+props.uid+'&session='+props.session+'&action=rpt_sub&agent='+props.agent+'&F1031'+F1031+'&F254='+F254+'&F1034=3');
		fetch(props.apiServer + '?uid='+props.uid+'&session='+props.session+'&action=rpt_sub&agent='+props.agent+'&F1031='+F1031+'&F254='+F254+'&F1034=3')
		.then(response => response.json())
		.then(result => {
			console.log('RptSubDeptSingleTotal.js rpt_sub result returned');
			console.log('RptSubDeptSingleTotal.js rpt_sub result: '+JSON.stringify(result));
			if(result.data){
				setRptSub(result.data);
			}
			else{
				props.errorMessage("Error retrieving rpt_sub data: "+result.message);
			}
		});
	}

	let rptData = rpt_sub.map((record) => record.F04).filter(onlyUnique).sort().map((sdpNo) => {
		return ({
			code: sdpNo,
			description: sdpName(rpt_sub, sdpNo),
			qty: rptTotalQty(rpt_sub.filter((rpt) => rpt.F04 === sdpNo), 3),
			dollars: rptTotal(rpt_sub.filter((rpt) => rpt.F04 === sdpNo), 3)
		});
	});

	return (
		<ReportTab id='SubDeptSingleTotal'>
			<ReportTab.Header parentId='SubDeptSingleTotal' title='Sub-dept. Single Total'>
				<BtnRefresh parentId='SubDeptSingleTotal' action={refresh} />
				<BtnExpand parentId='SubDeptSingleTotal' action={refresh} />
			</ReportTab.Header>
			<ReportTab.Expand parentId='SubDeptSingleTotal'>
				<RptSingleTotal title='Sub-dept. Net Sales' description='Sub-dept.' data={rptData} />
			</ReportTab.Expand>
		</ReportTab>
	);
}

export default connect(
        mapStateToProps,
        mapDispatchToProps
)(RptSubDeptSingleTotal);

